import { useEffect } from 'react';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import fetch from 'features/common/fetch';
import campaignManagers from 'features/views/campaignDashboards/campaignManagers';
import campaigns from 'features/views/campaignDashboards/campaigns';
import dashboardSidebar from 'features/views/campaignDashboards/sidebar';
import dashboardStructure from 'features/views/campaignDashboards/structure';

import ManagersTable from './components/ManagersTable';

const { urls } = fetch.constants;

export const DashboardRegion = () => {
	const dispatch = useDispatch();

	const campaignId = useSelector(dashboardStructure.selectors.getCampaignId);
	const organizationStructure = useSelector(dashboardStructure.selectors.getStructure);
	const campaign = useSelector((state) => campaigns.selectors.getCampaignById(state, campaignId));

	useEffect(() => {
		if (!isEmpty(campaign)) {
			dispatch(
				dashboardSidebar.actions.fetchSummary(campaign, urls.dashboardRegionSummary, organizationStructure),
			);
			dispatch(campaignManagers.actions.getManagers(campaign.id, organizationStructure)); // fetch regionManagers
		}
		// eslint-disable-next-line
	}, [dispatch, campaign]);

	return <ManagersTable campaignType={campaign.type} />;
};

export default DashboardRegion;
